import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _get from "@babel/runtime-corejs3/helpers/get";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
var _excluded = ["name"],
  _excluded2 = ["displayName"],
  _excluded3 = ["id"];
function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);
  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);
    enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = function () {
    if ("undefined" == typeof Reflect || !_Reflect$construct) return !1;
    if (_Reflect$construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var result,
      Super = _getPrototypeOf(Derived);
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = _Reflect$construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);
    return _possibleConstructorReturn(this, result);
  };
}
import React, { forwardRef, useCallback, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import { defaultAvailableValuePropType, dataTypeShape, availableValueObjectShape, DATA_TYPE_OBJECT } from "@jutro/prop-types";
import { uniqueInnerId, useControlled, useId, useCombinedRefs } from "@jutro/platform";
import { isEmptyValue, isNilValue } from "@jutro/data";
import { FieldComponent } from "../FieldComponent/FieldComponent";
import { tryToCastToBoolean, findAvailableValue, isAvailableValuesCodeNameObject } from "../FieldComponent/utils";
import { RadioGroupContext } from "./RadioContext";
import { isNodeOrNull } from "./utils";
var RadioGroupInner = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    valueProp = _ref.value,
    accessibilityProps = _ref.accessibilityProps,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    name = _ref.name,
    id = _ref.id,
    innerRef = useRef(null),
    combinedRef = useCombinedRefs(innerRef, ref),
    generatedName = uniqueInnerId(id, "name").name,
    _useControlled = useControlled({
      value: valueProp,
      defaultValue: null
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1],
    _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    focus = _useState2[0],
    setFocus = _useState2[1],
    handleChange = useCallback(function (event) {
      setValue(event.target.value), null == onChange || onChange(event.target.value);
    }, [onChange, setValue]),
    handleFocus = useCallback(function (event) {
      var _combinedRef$current;
      setFocus(event.target.value), !isNodeOrNull(event.relatedTarget) || null !== (_combinedRef$current = combinedRef.current) && void 0 !== _combinedRef$current && _combinedRef$current.contains(event.relatedTarget) || null == onFocus || onFocus(event);
    }, [combinedRef, onFocus]),
    handleBlur = useCallback(function (event) {
      var _combinedRef$current2;
      !isNodeOrNull(event.relatedTarget) || null !== (_combinedRef$current2 = combinedRef.current) && void 0 !== _combinedRef$current2 && _combinedRef$current2.contains(event.relatedTarget) || (null == onBlur || onBlur(event), setFocus(null));
    }, [combinedRef, onBlur]),
    radioGroupContext = useMemo(function () {
      return {
        name: null != name ? name : generatedName,
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        value: value,
        focus: focus,
        disabled: disabled
      };
    }, [name, generatedName, handleChange, handleFocus, handleBlur, value, focus, disabled]);
  return React.createElement("div", _extends({
    id: id,
    role: "radiogroup"
  }, accessibilityProps, {
    ref: combinedRef
  }), React.createElement(RadioGroupContext.Provider, {
    value: radioGroupContext
  }, children));
});
export var RadioGroupFieldComponent = function (_FieldComponent) {
  _inherits(RadioGroupFieldComponent, FieldComponent);
  var _super = _createSuper(RadioGroupFieldComponent);
  function RadioGroupFieldComponent() {
    var _context, _this;
    _classCallCheck(this, RadioGroupFieldComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    return _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args)), _defineProperty(_assertThisInitialized(_this), "getDataTypeAwareSelectedValue", function () {
      var _this$props = _this.props,
        dataType = _this$props.dataType,
        value = _this$props.value;
      if (dataType === DATA_TYPE_OBJECT && !isEmptyValue(value)) {
        var selectedValue = isNilValue(value.code) ? value.id : value.code;
        return !isNilValue(selectedValue) && selectedValue.toString() || void 0;
      }
      return value;
    }), _defineProperty(_assertThisInitialized(_this), "translateObjectValue", function (targetValue) {
      var availableValues = _this.props.availableValues,
        availableValue = null == availableValues ? void 0 : _findInstanceProperty(availableValues).call(availableValues, findAvailableValue(targetValue));
      if (void 0 !== availableValue) {
        if (isAvailableValuesCodeNameObject(availableValue)) {
          availableValue.name;
          var _rest = _objectWithoutProperties(availableValue, _excluded);
          return _objectSpread({
            name: _this.translator(availableValue.name)
          }, _rest);
        }
        availableValue.displayName;
        var rest = _objectWithoutProperties(availableValue, _excluded2);
        return _objectSpread({
          displayName: _this.translator(availableValue.displayName)
        }, rest);
      }
    }), _defineProperty(_assertThisInitialized(_this), "handleAvailableValuesValueChange", function (targetValue) {
      if (_this.props.dataType === DATA_TYPE_OBJECT) _this.notifyChange(_this.translateObjectValue(targetValue));else _this.notifyChange(tryToCastToBoolean(targetValue));
    }), _this;
  }
  return _createClass(RadioGroupFieldComponent, [{
    key: "render",
    value: function () {
      return _get(_getPrototypeOf(RadioGroupFieldComponent.prototype), "render", this).call(this);
    }
  }, {
    key: "generateAccessibilityProperties",
    value: function () {
      var translator = this.translator,
        label = this.props.label;
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(RadioGroupFieldComponent.prototype), "generateAccessibilityProperties", this).call(this)), {}, {
        "aria-label": translator(label)
      });
    }
  }, {
    key: "renderControl",
    value: function (_ref2) {
      var children = _ref2.children,
        disabled = _ref2.disabled,
        onFocus = _ref2.onFocus,
        onBlur = _ref2.onBlur,
        innerRef = _ref2.innerRef,
        id = _ref2.id,
        name = _ref2.name;
      return React.createElement(RadioGroupInner, {
        disabled: disabled,
        value: this.getDataTypeAwareSelectedValue(),
        accessibilityProps: this.generateAccessibilityProperties(),
        onChange: this.handleAvailableValuesValueChange,
        onFocus: null != onFocus ? onFocus : void 0,
        onBlur: null != onBlur ? onBlur : void 0,
        id: id,
        name: name,
        ref: innerRef
      }, children);
    }
  }]), RadioGroupFieldComponent;
}();
export var RadioGroup = React.forwardRef(function (_ref3, ref) {
  var idProp = _ref3.id,
    rest = _objectWithoutProperties(_ref3, _excluded3),
    id = useId({
      default: idProp
    });
  return React.createElement(RadioGroupFieldComponent, _extends({
    id: id,
    innerRef: ref
  }, rest));
});
RadioGroup.displayName = "RadioGroup", RadioGroup.defaultProps = _objectSpread(_objectSpread({}, FieldComponent.defaultProps), {
  dataType: "string"
}), RadioGroup.propTypes = _objectSpread(_objectSpread({}, FieldComponent.propTypes), {}, {
  id: PropTypes.string,
  value: defaultAvailableValuePropType,
  dataType: dataTypeShape,
  availableValues: PropTypes.arrayOf(availableValueObjectShape.isRequired).isRequired,
  children: PropTypes.node,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf("undefined" != typeof window ? HTMLLabelElement : Object)
  })]),
  name: PropTypes.string
}), RadioGroupFieldComponent.__docgenInfo = {
  description: "",
  methods: [{
    name: "generateAccessibilityProperties",
    docblock: "generates accessibility properties for the field component\n@returns {object} set of applicable wai-aria tags",
    modifiers: [],
    params: [],
    returns: {
      description: "set of applicable wai-aria tags",
      type: {
        name: "AriaAttributes"
      }
    },
    description: "generates accessibility properties for the field component"
  }, {
    name: "getDataTypeAwareSelectedValue",
    docblock: "Get the code of the currently selected availableValue.\nIf using dataType=DATA_TYPE_OBJECT or DATA_TYPE_GW_REST_OBJECT, return the `code` from the value.\nOtherwise return the value itself\n\n@returns {any} - The selected value",
    modifiers: [],
    params: [],
    returns: {
      description: "The selected value",
      type: {
        name: "union",
        raw: "string | number",
        elements: [{
          name: "string"
        }, {
          name: "number"
        }]
      }
    },
    description: "Get the code of the currently selected availableValue.\nIf using dataType=DATA_TYPE_OBJECT or DATA_TYPE_GW_REST_OBJECT, return the `code` from the value.\nOtherwise return the value itself"
  }, {
    name: "translateObjectValue",
    docblock: null,
    modifiers: [],
    params: [{
      name: "targetValue",
      type: {
        name: "string"
      }
    }],
    returns: {
      type: {
        name: "union",
        raw: "AvailableValueObjectShape | undefined",
        elements: [{
          name: "AvailableValueObjectShape"
        }, {
          name: "undefined"
        }]
      }
    }
  }, {
    name: "handleAvailableValuesValueChange",
    docblock: null,
    modifiers: [],
    params: [{
      name: "targetValue",
      type: {
        name: "string"
      }
    }],
    returns: {
      type: {
        name: "void"
      }
    }
  }, {
    name: "renderControl",
    docblock: null,
    modifiers: [],
    params: [{
      name: "{\n    children,\n    disabled,\n    onFocus,\n    onBlur,\n    innerRef,\n    id,\n    name,\n}: RadioGroupCommonProps & {\n    id: string;\n    innerRef?: Ref<HTMLDivElement>;\n}",
      type: {
        name: "intersection",
        raw: "RadioGroupCommonProps & {\n    id: string;\n    innerRef?: Ref<HTMLDivElement>;\n}",
        elements: [{
          name: "intersection",
          raw: "FieldComponentInheritedProps & {\n    /**\n     * The content to be rendered in a group - radios themselves and any additional markup\n     */\n    children?: ReactNode;\n    /**\n     * additional className applied to the top level of the component\n     */\n    className?: string;\n    /**\n     * If true, the entire radio group is disabled\n     */\n    disabled?: boolean;\n    /**\n     * name of the radio group, must be the same for all radios in the group https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-name\n     */\n    name?: string;\n    /**\n     * The id of the radiogroup div. Optional; auto-generated if not provided.\n     */\n    id?: string;\n}",
          elements: [{
            name: "FieldComponentInheritedProps"
          }, {
            name: "signature",
            type: "object",
            raw: "{\n    /**\n     * The content to be rendered in a group - radios themselves and any additional markup\n     */\n    children?: ReactNode;\n    /**\n     * additional className applied to the top level of the component\n     */\n    className?: string;\n    /**\n     * If true, the entire radio group is disabled\n     */\n    disabled?: boolean;\n    /**\n     * name of the radio group, must be the same for all radios in the group https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-name\n     */\n    name?: string;\n    /**\n     * The id of the radiogroup div. Optional; auto-generated if not provided.\n     */\n    id?: string;\n}",
            signature: {
              properties: [{
                key: "children",
                value: {
                  name: "ReactNode",
                  required: !1
                }
              }, {
                key: "className",
                value: {
                  name: "string",
                  required: !1
                }
              }, {
                key: "disabled",
                value: {
                  name: "boolean",
                  required: !1
                }
              }, {
                key: "name",
                value: {
                  name: "string",
                  required: !1
                }
              }, {
                key: "id",
                value: {
                  name: "string",
                  required: !1
                }
              }]
            }
          }]
        }, {
          name: "signature",
          type: "object",
          raw: "{\n    id: string;\n    innerRef?: Ref<HTMLDivElement>;\n}",
          signature: {
            properties: [{
              key: "id",
              value: {
                name: "string",
                required: !0
              }
            }, {
              key: "innerRef",
              value: {
                name: "Ref",
                elements: [{
                  name: "HTMLDivElement"
                }],
                raw: "Ref<HTMLDivElement>",
                required: !1
              }
            }]
          }
        }]
      }
    }],
    returns: {
      type: {
        name: "JSX.Element"
      }
    }
  }],
  displayName: "RadioGroupFieldComponent",
  props: {
    children: {
      required: !1,
      tsType: {
        name: "ReactNode"
      },
      description: "The content to be rendered in a group - radios themselves and any additional markup"
    },
    className: {
      required: !1,
      tsType: {
        name: "string"
      },
      description: "additional className applied to the top level of the component"
    },
    disabled: {
      required: !1,
      tsType: {
        name: "boolean"
      },
      description: "If true, the entire radio group is disabled"
    },
    name: {
      required: !1,
      tsType: {
        name: "string"
      },
      description: "name of the radio group, must be the same for all radios in the group https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-name"
    },
    id: {
      required: !0,
      tsType: {
        name: "string"
      },
      description: "The id of the radiogroup div. Optional; auto-generated if not provided."
    },
    innerRef: {
      required: !1,
      tsType: {
        name: "Ref",
        elements: [{
          name: "union",
          raw: "HTMLDivElement | null",
          elements: [{
            name: "HTMLDivElement"
          }, {
            name: "null"
          }]
        }],
        raw: "Ref<HTMLDivElement | null>"
      },
      description: ""
    }
  }
}, RadioGroup.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "RadioGroup",
  props: {
    dataType: {
      defaultValue: {
        value: "'string'",
        computed: !1
      },
      type: {
        name: "custom",
        raw: "dataTypeShape"
      },
      required: !1,
      description: "The format of the value"
    },
    id: {
      type: {
        name: "string"
      },
      required: !1,
      description: "The id of the radiogroup div. Optional; auto-generated if not provided."
    },
    value: {
      type: {
        name: "custom",
        raw: "defaultAvailableValuePropType"
      },
      required: !1,
      description: "Current selected value in case of controlled components"
    },
    availableValues: {
      type: {
        name: "arrayOf",
        value: {
          name: "custom",
          raw: "availableValueObjectShape.isRequired"
        }
      },
      required: !0,
      description: "Array of choice objects to display; choice objects contain 'code' and 'name'; if not provided, default 'Yes'/'No' will be used"
    },
    children: {
      type: {
        name: "node"
      },
      required: !1,
      description: "The content to be rendered in a group - radios themselves and any additional markup"
    },
    ref: {
      type: {
        name: "union",
        value: [{
          name: "func"
        }, {
          name: "shape",
          value: {
            current: {
              name: "instanceOf",
              value: "typeof window !== 'undefined' ? HTMLLabelElement : Object",
              required: !1
            }
          }
        }]
      },
      required: !1,
      description: 'React Ref to underlying `<div>` element with a role "radiogroup"'
    },
    name: {
      type: {
        name: "string"
      },
      required: !1,
      description: "name of the radio group, must be the same for all radios in the group https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-name"
    }
  },
  composes: ["../FieldComponent/FieldComponent"]
}, RadioGroupFieldComponent.__docgenInfo = {
  componentName: "RadioGroupFieldComponent",
  packageName: "@jutro/components",
  description: "",
  displayName: "RadioGroupFieldComponent",
  methods: [{
    name: "generateAccessibilityProperties",
    docblock: "generates accessibility properties for the field component\n@returns {object} set of applicable wai-aria tags",
    modifiers: [],
    params: [],
    returns: {
      description: "set of applicable wai-aria tags",
      type: {
        name: "object"
      }
    },
    description: "generates accessibility properties for the field component"
  }, {
    name: "getDataTypeAwareSelectedValue",
    docblock: "Get the code of the currently selected availableValue.\nIf using dataType=DATA_TYPE_OBJECT or DATA_TYPE_GW_REST_OBJECT, return the `code` from the value.\nOtherwise return the value itself\n\n@returns {any} - The selected value",
    modifiers: [],
    params: [],
    returns: {
      description: "The selected value",
      type: {
        name: "any"
      }
    },
    description: "Get the code of the currently selected availableValue.\nIf using dataType=DATA_TYPE_OBJECT or DATA_TYPE_GW_REST_OBJECT, return the `code` from the value.\nOtherwise return the value itself"
  }, {
    name: "translateObjectValue",
    docblock: null,
    modifiers: [],
    params: [{
      name: "targetValue",
      optional: !1,
      type: null
    }],
    returns: null
  }, {
    name: "handleAvailableValuesValueChange",
    docblock: null,
    modifiers: [],
    params: [{
      name: "targetValue",
      optional: !1,
      type: null
    }],
    returns: null
  }, {
    name: "renderControl",
    docblock: null,
    modifiers: [],
    params: [{
      name: "{ children, disabled, onFocus, onBlur, innerRef, id, name, }",
      optional: void 0,
      type: null
    }],
    returns: null
  }],
  actualName: "RadioGroupFieldComponent"
}, RadioGroup.__docgenInfo = {
  componentName: "RadioGroup",
  packageName: "@jutro/components",
  description: "",
  displayName: "RadioGroup",
  methods: [],
  actualName: "RadioGroup",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: !1,
      description: "The id of the radiogroup div. Optional; auto-generated if not provided."
    },
    value: {
      type: {
        name: "union",
        value: [{
          name: "string"
        }, {
          name: "bool"
        }, {
          name: "number"
        }, {
          name: "custom",
          raw: "availableValueObjectShape"
        }]
      },
      required: !1,
      description: "Current selected value in case of controlled components"
    },
    dataType: {
      type: {
        name: "enum",
        value: [{
          value: "'object'",
          computed: !1
        }, {
          value: "'string'",
          computed: !1
        }]
      },
      required: !1,
      description: "The format of the value",
      defaultValue: {
        value: "'string'",
        computed: !1
      }
    },
    availableValues: {
      type: {
        name: "arrayOf",
        value: {
          name: "union",
          value: [{
            name: "shape",
            value: {
              code: {
                name: "union",
                value: [{
                  name: "string"
                }, {
                  name: "number"
                }],
                required: !1
              },
              name: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              subtitle: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              secondaryLabel: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            }
          }, {
            name: "shape",
            value: {
              id: {
                name: "union",
                value: [{
                  name: "string"
                }, {
                  name: "number"
                }],
                required: !1
              },
              displayName: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              subtitle: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              },
              secondaryLabel: {
                name: "custom",
                raw: "intlMessageShape",
                required: !1
              }
            }
          }]
        }
      },
      required: !0,
      description: "Array of choice objects to display; choice objects contain 'code' and 'name'; if not provided, default 'Yes'/'No' will be used"
    },
    children: {
      type: {
        name: "node"
      },
      required: !1,
      description: "The content to be rendered in a group - radios themselves and any additional markup"
    },
    ref: {
      type: {
        name: "union",
        value: [{
          name: "func"
        }, {
          name: "shape",
          value: {
            current: {
              name: "instanceOf",
              value: "typeof window !== 'undefined' ? HTMLLabelElement : Object",
              required: !1
            }
          }
        }]
      },
      required: !1,
      description: 'React Ref to underlying `<div>` element with a role "radiogroup"'
    },
    name: {
      type: {
        name: "string"
      },
      required: !1,
      description: "name of the radio group, must be the same for all radios in the group https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-name"
    }
  },
  composes: ["../FieldComponent/FieldComponent"]
};